import { useCallback } from 'react';

import { useAppDispatch } from 'app/store/store';
import { setCurrentAccountId } from 'app/shared/api/accountContext';
import { useSwitchCurrentAccountMutation } from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';
import { dataManagerServiceApi } from 'app/store/reducers/api/data-manager/dataManagerServiceApi';
import { jobManagerServiceApi } from 'app/store/reducers/api/job-manager/jobManagerServiceApi';
import { leadGenServiceApi } from 'app/store/reducers/api/leadgen/leadGenServiceApi';
import { n8nWebhookApi } from 'app/store/reducers/api/n8n/n8nWebhookApi';
import { emptyRagServerServicesApi } from 'app/store/reducers/api/rag-server/emptyRagServerServicesApi';
import { emptySpeak2MeServicesApi } from 'app/store/reducers/api/speak2me/emptySpeak2MeServicesApi';
import { notifyAccountChanged } from 'app/views/tenders/aoAccount';

// Resource APIs whose cached data is scoped to the active account.
const RESOURCE_APIS = [
  dataManagerServiceApi,
  jobManagerServiceApi,
  leadGenServiceApi,
  n8nWebhookApi,
  emptyRagServerServicesApi,
  emptySpeak2MeServicesApi,
];

// Switches the active account, then resets account-scoped resource caches so lists refetch.
export const useSwitchAccount = () => {
  const dispatch = useAppDispatch();
  const [switchCurrentAccount, { isLoading }] = useSwitchCurrentAccountMutation();

  const switchTo = useCallback(
    async (accountId: string) => {
      if (!accountId) return undefined;
      const profile = await switchCurrentAccount({ accountId }).unwrap();
      const active = profile?.currentAccount ?? accountId;
      setCurrentAccountId(active);
      RESOURCE_APIS.forEach(api => dispatch(api.util.resetApiState()));
      // The Appels d'Offres stores live outside RTK Query, so reset them explicitly.
      notifyAccountChanged(active);
      return profile;
    },
    [dispatch, switchCurrentAccount],
  );

  return { switchTo, isLoading };
};

export default useSwitchAccount;
